export default __webpack_public_path__ + "static/media/general.1fd87bed.webp";